import type { RouterInputs } from './types';

export type OptimizerJobInput = RouterInputs['screener']['optimizer']['createJob'];
export type OptimizerValidationSettings = Pick<
    OptimizerJobInput,
    'minCoverage' | 'featureMissingRateMax' | 'holdoutFraction' | 'embargoSeconds' | 'winsorPercentile' | 'winsorMaxCap'
>;

export const optionLegFields = [
    { number: 1, key: 'optionBuyingStrategyIdLeg1', resolvedKey: 'leg1' },
    { number: 2, key: 'optionBuyingStrategyIdLeg2', resolvedKey: 'leg2' },
    { number: 3, key: 'optionBuyingStrategyIdLeg3', resolvedKey: 'leg3' },
    { number: 4, key: 'optionBuyingStrategyIdLeg4', resolvedKey: 'leg4' },
    { number: 5, key: 'optionBuyingStrategyIdLeg5', resolvedKey: 'leg5' },
    { number: 6, key: 'optionBuyingStrategyIdLeg6', resolvedKey: 'leg6' }
] as const;

export type OptionLegField = (typeof optionLegFields)[number]['key'];
export type OptimizerOptionOverrides = Pick<OptimizerJobInput, OptionLegField>;

// Both preflight and creation consume this same request. Panel visibility is deliberately not an input.
export const buildOptimizerJobInput = (
    input: Omit<OptimizerJobInput, OptionLegField>,
    optionOverrides: OptimizerOptionOverrides
): OptimizerJobInput => ({
    ...input,
    ...(input.outcomeMode === 'strategy_exit' && input.entityType !== 'Cryptocurrency' ? optionOverrides : {})
});
